import React, { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { currYear, getWeek, passedDue } from "./App";
import { readOnlyPreview } from "./leagueStore";

export function Icon({ name, size = 22, ...props }) {
  const paths = {
    home: <><path d="m3 10 9-7 9 7v10a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1Z"/><path d="M9 21v-8h6v8"/></>,
    picks: <><rect x="4" y="3" width="16" height="18" rx="3"/><path d="m8 9 2 2 5-5M8 16h8"/></>,
    rankings: <><path d="M5 20V10h4v10M10 20V4h4v16M15 20v-7h4v7"/></>,
    keepers: <><path d="M12 3 4 6v6c0 5 8 9 8 9s8-4 8-9V6Z"/><path d="m8 12 3 3 5-6"/></>,
    stats: <><path d="M4 3v17h17M7 14l4-5 4 3 6-7"/></>,
    arrow: <path d="M5 12h14m-6-6 6 6-6 6"/>,
    clock: <><circle cx="12" cy="12" r="9"/><path d="M12 7v5l3 2"/></>,
    trophy: <><path d="M7 3h10v6a5 5 0 0 1-10 0ZM12 14v5M8 21h8M7 5H3v3a4 4 0 0 0 4 4M17 5h4v3a4 4 0 0 1-4 4"/></>,
    check: <path d="m5 12 4 4L19 6"/>,
    ball: <><path d="M4 20C0 9 9 0 20 4c4 11-5 20-16 16Z"/><path d="m8 16 8-8M8 12l4 4M12 8l4 4"/></>,
  };
  return <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" {...props}>{paths[name] || paths.ball}</svg>;
}

export const navigation = [
  ["/", "Home", "home"], ["/pickem", "Pick 'Em", "picks"],
  ["/powerranking", "Rankings", "rankings"], ["/keeperselection", "Keepers", "keepers"],
  ["/stats", "Stats", "stats"],
];

export function AppFrame({ children, onSignIn, onSignOut, authError }) {
  const { pathname } = useLocation();
  const [, tick] = useState(0);
  useEffect(() => { const id = setInterval(() => tick(t => t + 1), 15000); return () => clearInterval(id); }, []);
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  const signedIn = Boolean(localStorage.getItem("email"));
  const guest = localStorage.getItem("name") === "guest";
  const name = guest ? "Guest" : (localStorage.getItem("name") || "League member").split(" ")[0];
  const nav = navigation.map(([path, label, icon]) => <NavLink key={path} to={path} end={path === "/"}><Icon name={icon} size={20}/><span>{label}</span></NavLink>);
  return <div className="league-app">
    <a className="skip-link" href="#main-content">Skip to content</a>
    <header className="site-header">
      <Link to="/" className="brand" aria-label="Pick Em home"><span className="brand-mark"><Icon name="ball" size={26}/></span><span>PICK<span className="brand-light">EM</span><small>THE LEAGUE COMPANION</small></span></Link>
      <nav className="desktop-nav" aria-label="Main navigation">{signedIn && nav}</nav>
      <div className="account-area"><span className="season-label">{currYear} SEASON</span>{signedIn ? <><span className="avatar" aria-hidden="true">{name.charAt(0)}</span><button className="text-button" onClick={onSignOut}>{guest ? "Exit guest" : "Log out"}</button></> : <button className="button-primary" onClick={onSignIn}>Sign in</button>}</div>
    </header>
    <div className="week-strip"><div><span className="live-dot"/> WEEK {getWeek()} <span className="strip-divider">/</span> {passedDue() ? "Weekly entries closed" : "Your next bragging rights start here."}</div><span><Icon name="clock" size={15}/> Thursday · 7:30 p.m. CT</span></div>
    {readOnlyPreview && <div className="preview-notice">Local preview · League data is read-only. Submissions are disabled.</div>}
    {authError && <div className="inline-notice error" role="alert">{authError}</div>}
    <main id="main-content" className={`main-content route-${pathname.split('/')[1].toLowerCase() || 'home'}`}>{children}</main>
    <footer className="site-footer"><span>PICKEM <span>·</span> Built for the league.</span><span>{currYear} season · Powered by Sleeper</span></footer>
    {signedIn && <nav className="mobile-nav" aria-label="Mobile navigation">{nav}</nav>}
  </div>;
}

export function PageHeading({ eyebrow, title, description, children }) {
  return <div className="page-heading"><div><p className="eyebrow">{eyebrow || `THE ${currYear} SEASON`}</p><h1>{title}</h1>{description && <p className="page-description">{description}</p>}</div>{children}</div>;
}
